import { RequestStatus } from "@core-ui/hooks/useApi";
import type { UnpublishedCatalog } from "@ext/enterprise-cloud/types/UnpublishedCatalog";
import t from "@ext/localization/locale/translate";
import { ScrollShadowContainer } from "@ui-kit/ScrollShadowContainer";
import { Skeleton } from "@ui-kit/Skeleton";
import { TextOverflowTooltip } from "@ui-kit/Tooltip";

const PREFIX = "enterprise-cloud.sign-out";

const UnpublishedCatalogList = ({ catalogs }: { catalogs: UnpublishedCatalog[] }) => (
	<div className="rounded-md border">
		<ScrollShadowContainer className="max-h-[36vh]">
			<ul className="space-y-1 px-3 py-2">
				{catalogs.map((catalog) => (
					<li className="mb-0 flex min-w-0 items-baseline justify-between gap-3 leading-5" key={catalog.name}>
						<TextOverflowTooltip className="text-primary-fg">{catalog.title}</TextOverflowTooltip>
						<span className="shrink-0 text-xs text-muted">{t(`${PREFIX}.reason.${catalog.reason}`)}</span>
					</li>
				))}
			</ul>
		</ScrollShadowContainer>
	</div>
);

interface GesCloudSignOutWebDescriptionProps {
	catalogs: UnpublishedCatalog[] | null;
	status: RequestStatus;
}

const GesCloudSignOutWebDescription = ({ catalogs, status }: GesCloudSignOutWebDescriptionProps) => {
	if (status === RequestStatus.Init || status === RequestStatus.Loading) return <Skeleton className="h-5 w-full" />;
	if (status === RequestStatus.Error) return <p>{t(`${PREFIX}.web-description`)}</p>;
	if (!catalogs.length) return <p>{t(`${PREFIX}.description`)}</p>;

	return (
		<div className="flex min-w-0 flex-col gap-3">
			<p>{t(`${PREFIX}.unpublished-catalogs`)}</p>
			<UnpublishedCatalogList catalogs={catalogs} />
		</div>
	);
};

export default GesCloudSignOutWebDescription;
